import { fillActionValues } from "api/actions"

const getCustomerData = () => ({
  email: `stussy-${Math.floor(Math.random() * 1000000)}@evopark.de`,
  password: "12345678",
  customerType: "person",
  name: "Edward Park",
  bornOn: "1990-01-24",
  phoneNumber: "0245786521",
  streetAddress: "33 Sedenstrasse",
  postalCode: "50668",
  addressLocality: "Köln",
  addressCountryCode: "DE",
  deliveryAddress: false,
  accountHolder: "Edward Park",
  iban: "DE23100000001234567890",
  bic: "MARKDEF1100",
  remarks: "DEV - auto-generated",
  terms: true,
  privacyPolicy: true,
})

const getCompanyData = () => ({
  email: `stussy-company-${Math.floor(Math.random() * 1000000)}@evopark.de`,
  password: "12345678",
  customerType: "company",
  name: "Stussy company",
  contactName: "Jack President",
  contactDepartment: "Parking Dpt",
  costCenter: "Money Dpt",
  phoneNumber: "0245786543",
  streetAddress: "7 StartupStreet",
  postalCode: "50668",
  addressLocality: "Köln",
  addressCountryCode: "DE",
  deliveryAddress: false,
  accountHolder: "Edward Park",
  iban: "DE23100000001234567890",
  bic: "MARKDEF1100",
  remarks: "DEV - company - auto-generated",
  terms: true,
  privacyPolicy: true,
})

const fillSignupWith = (data) => (action) => fillActionValues(action, data)

export const fillSignupWithCustomer = fillSignupWith(getCustomerData())
export const fillSignupWithCompany = fillSignupWith(getCompanyData())
